module.exports = __webpack_public_path__ + "img/galerie-8.59588ab3.jpg";